/**
 * แกะ validation error รายฟิลด์ออกจาก response body ของ API
 *
 * backend ส่ง 422 (และบางเคส 400) มาในรูป
 *   { message: 'The given data was invalid.', errors: { sku: ['SKU ซ้ำ'], price: ['ต้องมากกว่า 0'] } }
 * ซึ่ง `message` เป็นข้อความกลางๆ ที่ผู้ใช้เอาไปทำอะไรต่อไม่ได้ ตัวที่มีประโยชน์จริงคือใน `errors`
 * ฟังก์ชันนี้จึงยุบ `errors` ทุกฟิลด์ให้เป็น list เดียวเพื่อเอาไปแสดงบน toast
 *
 * ค่าใน errors อาจเป็น array หรือ string เดี่ยวก็ได้ จึงต้อง normalize ก่อน
 *
 * @param {*} data - response body (error.response.data)
 * @returns {string[]|null} รายการข้อความ error หรือ null ถ้าไม่มีข้อมูลรายฟิลด์
 */
export const getFieldErrorMessages = (data) => {
	const errors = data?.errors;

	if (!errors || typeof errors !== 'object') {
		return null;
	}

	const messages = Object.values(errors).reduce((accErrors, values) => {
		return [
			...accErrors,
			...(Array.isArray(values) ? values : [values]),
		];
	}, []);

	return messages.length ? messages : null;
};

/**
 * เลือกเนื้อหาที่ควรแสดงบน toast จาก error body
 *
 * ลำดับความสำคัญ: validation รายฟิลด์ > message จาก server > ข้อความ fallback
 * ถ้ามี error รายฟิลด์อันเดียวจะคืนเป็น string เพื่อให้ ToastBox แสดงเป็นบรรทัดเดียว
 * ถ้ามีหลายอันคืนเป็น array แล้ว ToastBox จะ render เป็น <ul>
 *
 * @param {*} data       - response body (error.response.data)
 * @param {string} fallback - ข้อความสำรองเมื่อ body ไม่มีอะไรใช้ได้
 * @returns {string|string[]}
 */
export const getErrorToastContent = (data, fallback) => {
	const fieldErrors = getFieldErrorMessages(data);

	if (fieldErrors) {
		return fieldErrors.length === 1 ? fieldErrors[0] : fieldErrors;
	}

	return data?.message || fallback;
};
